<template>
  <div>
    <f-data-table id="manage-redirects-table"
                  :expanded="true"
                  heading="Feed Redirects"
                  icon=""
                  :data-uri="data_uri"
                  :columns="columns"
                  :selectable-rows="false"
                  :server-side="true">
      <template slot="_actions">
        <div class="kt-portlet__head-toolbar">
          <div class="kt-portlet__head-wrapper">
            <button type="button" class="btn btn-ss-standout btn-icon-sm" @click="triggerCreateRedirectModal()">
              <i class="flaticon2-plus" />New Redirect
            </button>
          </div>
        </div>
      </template>

      <template #_filters>
        <f-data-table-filters target="manage-redirects-table"
                              :form-columns="2"
                              :expanded="false"
                              filter-layout="col">
          <template #name="props">
            <f-data-table-filter field="customer_slug" display="Customer Slug"
                                 :scope="props" />
          </template>
          <template #description="props">
            <f-data-table-filter field="feed_file_name" display="Feed File Name"
                                 :scope="props" />
          </template>
        </f-data-table-filters>
      </template>

      <template #actions="props">
        <div class="row-action-cell">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-ss" @click="triggerEditRedirectModal(props.row)">
              <span class="la la-edit" />
            </button>
            <button type="button" class="btn btn-ss-danger" @click="props.do({ cb: () => deleteRedirect(props.row), reload_data: true })">
              <span class="la la-trash" />
            </button>
          </div>
        </div>
      </template>
    </f-data-table>
    <create-feed-redirect-modal name="create_feed_redirect_modal" />
    <edit-feed-redirect-modal v-if="redirect_to_edit" name="edit_feed_redirect_modal" :target-redirect="redirect_to_edit" />
  </div>
</template>

<script>
import FDataTable from "VuePartials/App/Storage/FDataTable/FDataTable.vue";
import FDataTableFilters from "VuePartials/App/Storage/FDataTable/FDataTableFilters.vue";
import FDataTableFilter from "VuePartials/App/Storage/FDataTable/FDataTableFilter.vue";
import CreateFeedRedirectModal from "VueModals/FeedRedirects/CreateFeedRedirectModal.vue";
import EditFeedRedirectModal from "VueModals/FeedRedirects/EditFeedRedirectModal.vue";

export default {
  components: {
    FDataTableFilter,
    FDataTableFilters,
    FDataTable,
    CreateFeedRedirectModal,
    EditFeedRedirectModal,
  },
  data() {
    return {
      data_uri: '/api/v1/admin/feed-redirects',
      columns: [
        {
          display: "Customer Slug",
          field: "customer_slug",
        },
        {
          display: "Feed File Name",
          field: "feed_file_name",
        },
        {
          display: "Response Code",
          field: "response_code",
        },
        {
          display: "Redirect To",
          field: "to_url",
        },
        {
          display: "Comment",
          field: "comment",
        },
        {
          field: `actions`,
          display: ``,
          sortable: false,
          width: 150,
          never_clip: true,
        },
      ],
      redirect_to_edit: null,
    };
  },
  methods: {
    triggerCreateRedirectModal() {
      this.fireModal('create_feed_redirect_modal');
    },
    triggerEditRedirectModal(redirect) {
      this.redirect_to_edit = redirect;
      Vue.nextTick(() => {
        this.fireModal('edit_feed_redirect_modal');
      });
    },
    deleteRedirect(redirect) {
      axios.delete(`/api/v1/admin/feed-redirects/${redirect.id}`).then(() => {
        toastr.success("Redirect deleted.");
      }).catch(() => {
        toastr.error("Unable to delete redirect. Please contact SharpStream Support.");
      });
    },
  },
};
</script>
